<template>
    <div class="mt-5 pt-4 lg:grid lg:grid-cols-12 lg:gap-x-6">
        <div v-if="outturn.ticket_one > 0" class="lg:col-span-4 rounded-lg shadow mb-6">
            <div class="bg-gray-100 rout-md p-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Ticket 1
            </div>
            <div class=" px-6 py-3">
                <div class="flex">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_one }}</span>
                </div>
                <div class="flex mt-2">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_one_wt | numberInThousands }}</span>
                </div>
            </div>
        </div>

        <div v-if="outturn.ticket_two > 0" class="lg:col-span-4 rounded-lg shadow mb-6">
            <div class="bg-gray-100 rout-md p-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Ticket 2
            </div>
            <div class=" px-6 py-3">
                <div class="flex">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_two }}</span>
                </div>
                <div class="flex mt-2">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_two_wt | numberInThousands }}</span>
                </div>
            </div>
        </div>

        <div v-if="outturn.ticket_three > 0" class="lg:col-span-4 rounded-lg shadow mb-6">
            <div class="bg-gray-100 rout-md p-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Ticket 3
            </div>
            <div class=" px-6 py-3">
                <div class="flex">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_three }}</span>
                </div>
                <div class="flex mt-2">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_three_wt | numberInThousands }}</span>
                </div>
            </div>
        </div>

        <div v-if="outturn.ticket_four > 0" class="lg:col-span-4 rounded-lg shadow mb-6">
            <div class="bg-gray-100 rout-md p-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Ticket 4
            </div>
            <div class=" px-6 py-3">
                <div class="flex">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_four }}</span>
                </div>
                <div class="flex mt-2">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_four_wt | numberInThousands }}</span>
                </div>
            </div>
        </div>

        <div v-if="outturn.ticket_five > 0" class="lg:col-span-4 rounded-lg shadow mb-6">
            <div class="bg-gray-100 rout-md p-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Ticket 5
            </div>
            <div class=" px-6 py-3">
                <div class="flex">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_five }}</span>
                </div>
                <div class="flex mt-2">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_five_wt | numberInThousands }}</span>
                </div>
            </div>
        </div>

        <div v-if="outturn.ticket_six > 0" class="lg:col-span-4 rounded-lg shadow mb-6">
            <div class="bg-gray-100 rout-md p-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Ticket 6
            </div>
            <div class=" px-6 py-3">
                <div class="flex">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_six }}</span>
                </div>
                <div class="flex mt-2">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_six_wt | numberInThousands }}</span>
                </div>
            </div>
        </div>

        <div v-if="outturn.ticket_seven > 0" class="lg:col-span-4 rounded-lg shadow mb-6">
            <div class="bg-gray-100 rout-md p-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Ticket 7
            </div>
            <div class=" px-6 py-3">
                <div class="flex">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_seven }}</span>
                </div>
                <div class="flex mt-2">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_seven_wt | numberInThousands }}</span>
                </div>
            </div>
        </div>

        <div v-if="outturn.ticket_eight > 0" class="lg:col-span-4 rounded-lg shadow mb-6">
            <div class="bg-gray-100 rout-md p-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Ticket 8
            </div>
            <div class=" px-6 py-3">
                <div class="flex">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_eight }}</span>
                </div>
                <div class="flex mt-2">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_eight_wt | numberInThousands }}</span>
                </div>
            </div>
        </div>

        <div v-if="outturn.ticket_nine > 0" class="lg:col-span-4 rounded-lg shadow mb-6">
            <div class="bg-gray-100 rout-md p-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Ticket 9
            </div>
            <div class=" px-6 py-3">
                <div class="flex">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_nine }}</span>
                </div>
                <div class="flex mt-2">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_nine_wt | numberInThousands }}</span>
                </div>
            </div>
        </div>

        <div v-if="outturn.ticket_ten > 0" class="lg:col-span-4 rounded-lg shadow mb-6">
            <div class="bg-gray-100 rout-md p-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Ticket 10
            </div>
            <div class=" px-6 py-3">
                <div class="flex">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_ten }}</span>
                </div>
                <div class="flex mt-2">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_ten_wt | numberInThousands }}</span>
                </div>
            </div>
        </div>

        <div v-if="outturn.ticket_eleven > 0" class="lg:col-span-4 rounded-lg shadow mb-6">
            <div class="bg-gray-100 rout-md p-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Ticket 11
            </div>
            <div class=" px-6 py-3">
                <div class="flex">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_eleven }}</span>
                </div>
                <div class="flex mt-2">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_eleven_wt | numberInThousands }}</span>
                </div>
            </div>
        </div>

        <div v-if="outturn.ticket_twelve > 0" class="lg:col-span-4 rounded-lg shadow mb-6">
            <div class="bg-gray-100 rout-md p-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Ticket 12
            </div>
            <div class=" px-6 py-3">
                <div class="flex">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_twelve }}</span>
                </div>
                <div class="flex mt-2">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_twelve_wt | numberInThousands }}</span>
                </div>
            </div>
        </div>

        <div v-if="outturn.ticket_thirteen > 0" class="lg:col-span-4 rounded-lg shadow mb-6">
            <div class="bg-gray-100 rout-md p-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Ticket 13
            </div>
            <div class=" px-6 py-3">
                <div class="flex">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_thirteen }}</span>
                </div>
                <div class="flex mt-2">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_thirteen_wt | numberInThousands }}</span>
                </div>
            </div>
        </div>

        <div v-if="outturn.ticket_fourteen > 0" class="lg:col-span-4 rounded-lg shadow mb-6">
            <div class="bg-gray-100 rout-md p-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Ticket 14
            </div>
            <div class=" px-6 py-3">
                <div class="flex">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_fourteen }}</span>
                </div>
                <div class="flex mt-2">
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                    <span class="text-gray-600 font-medium text-sm pl-2 font-mono">{{ outturn.ticket_fourteen_wt | numberInThousands }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        outturn: {
            type: Object,
            required: true,
            defualt: {}
        }
    },
}
</script>
